import FormHelperText from '@material-ui/core/FormHelperText';
import * as React from 'react';
export const renderFromHelper = ({ touched, error }) => {
    if (!(touched && error)) {
        return;
    }
    else {
        return React.createElement(FormHelperText, null, touched && error);
    }
};
//# sourceMappingURL=renderFieldError.js.map